import { CustomerAddress } from 'models/CustomerAddress';
import { rm } from 'utils';
import { rule, isValidEmail, required } from 'components/Shared/Form';
import { isValidPhoneNumber } from 'views/CheckoutPage/validation';
import { CustomerContact } from 'models/CustomerContact';
import { BaseAction, BaseFormAction } from './types';

export const addressChanged = (
  address: CustomerAddress,
  email: string,
  dispatch: (action: BaseAction) => void
) => {
  dispatch({ type: 'address', value: address });
  dispatch({ type: 'email', value: email });
};

export const addressLookupValidationError = (dispatch: (action: BaseAction) => void) => {
  dispatch({
    type: 'addressError',
    value: rm('customerpage_returns_validation_error_addresslookup')
  });
};

export const contactOptionChanged = (
  contactOption: CustomerContact,
  dispatch: (action: BaseFormAction) => void
) => {
  dispatch({ type: 'contactOption', value: contactOption });
  dispatch({ type: 'contactOptionError', value: '' });
};

export const nameRule = rule(() => rm('customerpage_form_name_error'), required);
export const emailRule = rule(() => rm('customerservice_shared_error_email'), isValidEmail);
export const phoneRule = rule(() => rm('sip_error_mobile_number'), isValidPhoneNumber);
